import { FormField, type RadioButtonGroupOption } from '@innovationdepartment/proxima-ui';
import { IntegrationType } from 'types/integrations';
import ContentContainer from 'ui/Modals/CreateSeedAudiencesModal/Layout/ContentContainer';

const AdPlatformSelection = () => {
  const platforms: RadioButtonGroupOption[] = [
    { label: 'Facebook', value: IntegrationType.Facebook }
  ];

  return (
    <ContentContainer title="Ad platform">
      <FormField name="integrationType" type="radio" options={platforms} />
    </ContentContainer>
  );
};

export default AdPlatformSelection;
